import { Fragment, ReactNode } from "react"
import Footer from "components/footer"
import Header from "components/header"
import Nav from "components/sideNav"
import Container from "components/common/Container"

interface IPageTemplate {
    children: ReactNode,
    isFooter?: boolean
    isHeaderChange?: boolean
    background?: string
    overLay?: boolean
}

const MyPageTemplate = ({
    children, isFooter = true, isHeaderChange = false, background, overLay = false
}: IPageTemplate) => {
    return (
        <Fragment>
            <section className={`${background ? background : 'bg-base'}`}>
                <Header
                    isHeaderChange={isHeaderChange}
                    isOverLay={overLay}
                />
                <Container className="flex gap-10 overflow-hidden">
                    <Nav />
                    <div className="flex-1 min-w-0">
                        {children}
                    </div>
                </Container>
                {
                    isFooter &&
                    <Footer />
                }
            </section>
        </Fragment>
    )
}

export default MyPageTemplate